import React from 'react'
import Studentassignment from '../../components/student/studentassignment'
export default function Assignments() {
  return (
    <div>
        <Studentassignment/>
    </div>
  )
}
